import axios, { AxiosError } from 'axios';

import { URL_CONSTANTS } from '../../../../constants/urlConstants';
import { generateWidgetLayout } from '../../Widget/helpers/dashboard-layout.helpers';

export const getDashboardById = async (dashboardId: number) => {
  try {
    const response = await axios.get(
      `${URL_CONSTANTS.API.BASE_URL}/dashboard/manage/${dashboardId}`
    );
    return {
      error: false,
      message: 'Dasboard fetched successfully.',
      data: response?.data ?? {},
    };
  } catch (error) {
    console.error(error);
    return {
      error: true,
      message:
        error instanceof AxiosError
          ? error?.response?.data?.error
          : 'Error fetching',
      data: {},
    };
  }
};
export const upDateDashboard = async (
  dashboardId: number,
  widgetTemplateIds: number[]
) => {
  try {
    const { data: addWidgetData } = await axios.post(
      `${URL_CONSTANTS.API.BASE_URL}/dashboard/widgets`,
      {
        dashboard_id: dashboardId,
        widget_templates: widgetTemplateIds,
      }
    );

    const addedWidgets = addWidgetData?.widgets;

    if (!Array.isArray(addedWidgets) || addedWidgets.length === 0) {
      return {
        error: true,
        message: 'No widgets returned from add widget API.',
        data: {},
      };
    }

    const generatedLayout = generateWidgetLayout({
      widgetQuery: addedWidgets,
      layout: [],
    });

    const patchObj = addedWidgets.map((widgetItem, index) => {
      const layoutItem = generatedLayout[index];

      return {
        widget_id: widgetItem?.widget_id,
        dashboard_id: widgetItem?.dashboard_id,

        name: widgetItem?.name,
        description: widgetItem?.description,

        width: layoutItem?.w,
        height: layoutItem?.h,

        x_axis_position: layoutItem?.x,
        y_axis_position: layoutItem?.y,

        index: layoutItem?.i,

        chart_type: widgetItem?.chart_type || 'bar_chart',

        custom_properties: widgetItem?.custom_properties || {},
      };
    });

    const { data: patchData } = await axios.patch(
      `${URL_CONSTANTS.API.BASE_URL}/dashboard/widgets/multi-edit`,
      patchObj
    );

    return {
      error: false,
      message: patchData?.message || 'Dashboard updated successfully.',
      data: patchData ?? {},
    };
  } catch (error) {
    console.error('upDateDashboard error:', error);

    return {
      error: true,
      message:
        error instanceof AxiosError
          ? error?.response?.data?.error ||
            error?.response?.data?.message ||
            'Error updating dashboard.'
          : 'Error updating dashboard.',
      data: {},
    };
  }
};
